import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useMode } from '@/app/context/useMode';
import { getAssetUrl } from '@/helpers/commonFunctions';
import { RobotProvider } from '@/plugin/src';
import { RobotWrapperListening } from './robotStates/robotListning';
import { RobotWrapperSpeaking } from './robotStates/robotSpeaking';
import { RobotWrapperStanding } from './robotStates/robotStanding';
import { RobotWrapperThinking } from './robotStates/robotTinking';
import { RobotWrapperTyping } from './robotStates/robotTyping';
export function AudioVisualizer({ agentState, audioTrack, setAgentIsReady, chat, }) {
    const { mode, setMode } = useMode();
    const BASE_PATH = getAssetUrl('').replace(/\/$/, '');
    useEffect(() => {
        setMode('inline');
    }, []);
    const typingAudioRef = useRef(null);
    useEffect(() => {
        if (!typingAudioRef.current) {
            typingAudioRef.current = new Audio(getAssetUrl('/assets/sound/typing.mp3'));
            typingAudioRef.current.loop = true;
            typingAudioRef.current.volume = 0.4;
        }
        if (agentState === 'thinking') {
            typingAudioRef.current.play().catch(() => { });
        }
        else {
            typingAudioRef.current.pause();
            typingAudioRef.current.currentTime = 0;
        }
        return () => {
            var _a;
            (_a = typingAudioRef.current) === null || _a === void 0 ? void 0 : _a.pause();
        };
    }, [agentState]);
    const assetsBasePath = `${BASE_PATH}/robot-assets`;
    return (_jsx(_Fragment, { children: agentState === 'connecting' ? (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperStanding, {}) })) : agentState === 'listening' && chat ? (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperStanding, {}) })) : agentState === 'listening' ? (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperListening, {}) })) : agentState === 'thinking' ? (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperThinking, {}) })) : chat && agentState === 'speaking' ? (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperTyping, {}) })) : !chat && agentState === 'speaking' ? (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperSpeaking, {}) })) : (_jsx(RobotProvider, { mode: mode, targetElementId: "robot-container", assetsBasePath: assetsBasePath, children: _jsx(RobotWrapperListening, {}) })) }));
}
